import { useSidebarItems } from './sidebar-items';

type FilterOutSidebarProps = {
  sidebarItems: ReturnType<typeof useSidebarItems>;
  isAvailabilityVisible: boolean | undefined;
};

export const filterOutSidebarItems = (props: FilterOutSidebarProps) => {
  const { sidebarItems, isAvailabilityVisible } = props;

  const result = sidebarItems.map((section) => ({
    ...section,
    children: [...section.children],
  }));

  if (!isAvailabilityVisible) {
    const dashboardSection = result.find((s) => s.key === 'dashboard');
    if (dashboardSection) {
      dashboardSection.children = dashboardSection.children.filter(
        (item) => item.path !== 'availability/*'
      );
    }
  }

  return result;
};
